import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Live-checks a discount code against the current selection (debounced).
export default function useDiscount(code, subPrice, addonTotal) {
  const [res, setRes] = useState(null);
  useEffect(() => {
    const c = (code || '').trim();
    if (!c) { setRes(null); return undefined; }
    const t = setTimeout(() => {
      axios.post(`${API}/public/discount-codes/check`, { code: c, sub_price: subPrice, addon_total: addonTotal })
        .then((r) => setRes(r.data)).catch(() => setRes(null));
    }, 400);
    return () => clearTimeout(t);
  }, [code, subPrice, addonTotal]);
  const discount = res?.valid ? res.discount : 0;
  return { discount, label: res?.valid ? res.label : null, error: res && !res.valid ? res.error : null };
}

export const DiscountNote = ({ d, testid }) => {
  if (d.label) return <p className="text-xs text-emerald-700 mt-1" data-testid={`${testid}-ok`}>Code applied: {d.label} (-£{d.discount.toFixed(2).replace(/\.00$/, '')})</p>;
  if (d.error) return <p className="text-xs text-red-600 mt-1" data-testid={`${testid}-error`}>{d.error}</p>;
  return null;
};
